import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Avatar from '../../shared/avatar';
import StickoutBanner from '../../shared/stickout-banner';
import Name from './primary-content-components/name';
import Career from './primary-content-components/career';
import Blurb from './primary-content-components/blurb';
import Stats from './primary-content-components/stats';
import Actions from './primary-content-components/actions';
import Branding from './primary-content-components/branding';

const Container = styled(StickoutBanner)`
  ${props => props.theme.isLarge && `
    margin-top: -120px;
  `};

  ${props => props.theme.isXLarge && props.expanded && `
    border-radius: 9px 9px 6px 6px;
    height: 287px;
    margin-top: -148px;
  `};

  ${props => props.theme.isMobileOrTablet && props.expanded && `
    margin-top: -46px;
  `};

  ${props => props.theme.isMobile && props.expanded && `
    margin-top: -40px;
  `};
`;

const Profile = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(142, 163, 181, 0.3);
  border-top-style: hidden;

  ${props => (props.theme.isXLarge ? `
    border-radius: 0 0 6px 6px;
    height: 230px;
    padding-left: 20px;
    padding-right: 20px;
  ` : `
    padding-left: 32px;
    padding-right: 32px;
    width: auto;

    ${props.theme.isMobile && `
      margin-top: 16px;
      padding: 10px 20px 0 20px;
    `};
  `)};
`;

const TopWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  ${props => !props.theme.isXLarge && `
    flex-wrap: wrap;
  `};

`;

const AvatarContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${props => props.theme.isXLarge && `
    margin: 0;
    margin-right: 24px;
  `};


  & img[class^="avatar__Img"] {
    background-color: white;
    border: 2px solid white;
    border-radius: 6px;
    box-shadow: 0px 4px 8px rgba(50, 50, 71, 0.2);
    margin: 0px;

    ${props => props.theme.isMobileOrTablet && `
      margin-top: -80px;
      min-width: 160px;
      width: 160px;
      height: 160px;
    `};
    ${props => props.theme.isMobile && `
      margin-top: -54px;
      min-width: 120px;
      width: 120px;
      height: 120px;
    `};
    ${props => props.theme.isLarge && `
      margin-top: -16px;
      min-width: 176px;
      width: 176px;
      height: 176px;
    `};
    ${props => props.theme.isXLarge && `
      margin-top: -24px;
      min-width: 180px;
      width: 180px;
      height: 180px;
    `};
  }
`;

const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 2;

  ${props => !props.theme.isXLarge && `
    margin-top: 8px;
    width: 100%;
    order: 3;
  `};
`;

export default function PrimaryContent(props) {
  const useCompanyName = props.profile.isCompanyProfile && props.profile.organization;

  return (
    <Container expanded={!!props.showBranding}>
      {!!props.showBranding && <Branding {...props.profile.company} />}
      <Profile expanded={!!props.showBranding}>
        <TopWrapper>
          <AvatarContainer>
            <Avatar {...props.profile} slug={null} />
          </AvatarContainer>
          <DescriptionContainer>
            <Name name={useCompanyName ? props.profile.organization : props.profile.name.replace(/\.\s*$/, '')} />
            {!useCompanyName
              && (
              <>
                <Career {...props.profile} />
                <Blurb {...props.profile} />
              </>
              )}
          </DescriptionContainer>
          <Actions {...props} />
        </TopWrapper>
        <Stats {...props.stats} profileId={props.profile.id} />
      </Profile>
    </Container>
  );
}

PrimaryContent.propTypes = {
  profile: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    slug: PropTypes.string,
    organization: PropTypes.string,
    position: PropTypes.string,
    isCompanyProfile: PropTypes.bool,
    profilePictureUrl: PropTypes.string,
    blurb: PropTypes.string,
    activePartnership: PropTypes.shape({
      id: PropTypes.number,
    }),
    areasOfExpertise: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      slug: PropTypes.string,
      name: PropTypes.string,
    })),
    canPostWires: PropTypes.bool,
    company: PropTypes.shape({
      name: PropTypes.string,
      logo: PropTypes.string,
      color: PropTypes.string,
    }),
  }).isRequired,
  stats: PropTypes.shape({
    viewsCount: PropTypes.number,
    followersCount: PropTypes.number,
    wiresCount: PropTypes.number,
    since: PropTypes.string,
  }).isRequired,
  followed: PropTypes.bool.isRequired,
  isMyself: PropTypes.bool.isRequired,
  showBranding: PropTypes.bool.isRequired,
};
